(function () {
    'use strict';

    angular
        .module('oddPublicModule')
        .directive('fieldComponent', directive);

    function directive() {
        return {
            scope: true,
            template: '<div ng-include="getFieldTemplateUrl()"></div>',
            controller: ['$scope',
                function ($scope) {

                    $scope.getFieldTemplateUrl = function () {
                        return '/app/shared/odd/oddPublic/odd' + $scope.field.ODDQuestionType.ComponentType + '.' +
                            $scope.field.ODDQuestionType.CategoryCode + '.' +
                            $scope.field.ODDQuestionType.CategoryBehaviour + '.tpl.html';
                    };

                    $scope.getAttributeValue = function (attributeCode) {
                        var attr = _.find($scope.field.ODDQuestionAttributeValues, {Code: attributeCode});
                        return attr && attr.ValueText;
                    };

                }],
            link: function (scope, el, attr) {
                scope.record = null;
                scope.field = null;

                if (scope.ctxtCtrl.records && scope.ctxtCtrl.records[attr.recordIndex]) {
                    scope.record = scope.ctxtCtrl.records[attr.recordIndex];
                }
                if (scope.component.QuestionFields && scope.component.QuestionFields[attr.fieldIndex]) {
                    scope.field = scope.component.QuestionFields[attr.fieldIndex];
                }

                scope.templateId = attr.templateId;
            }
        };
    }
})();